import { normalizePassageText } from './passageText';

export interface LanguageGuardViolation {
  script: string;
  char: string;
  codepoint: string;
  position: number;
  snippet: string;
}

export interface ScriptRange {
  script: string;
  ranges: ReadonlyArray<readonly [number, number]>;
}

// Generated by scripts/generate_language_guard_ranges.py (Unicode 15.0.0).
export const BLOCKED_SCRIPT_RANGES: readonly ScriptRange[] = [
  { script: 'ARABIC', ranges: [[0x0600, 0x060a], [0x060c, 0x06ef], [0x06fa, 0x06ff], [0x0750, 0x077f], [0x0870, 0x088e], [0x0890, 0x0891], [0x0898, 0x08ff], [0xfb50, 0xfbc2], [0xfbd3, 0xfd3d], [0xfd40, 0xfd8f], [0xfd92, 0xfdc7], [0xfdcf, 0xfdcf], [0xfdf0, 0xfdfb], [0xfdfd, 0xfdff], [0xfe70, 0xfe74], [0xfe76, 0xfefc], [0x10efd, 0x10eff], [0x1ee00, 0x1ee03], [0x1ee05, 0x1ee1f], [0x1ee21, 0x1ee22], [0x1ee24, 0x1ee24], [0x1ee27, 0x1ee27], [0x1ee29, 0x1ee32], [0x1ee34, 0x1ee37], [0x1ee39, 0x1ee39], [0x1ee3b, 0x1ee3b], [0x1ee42, 0x1ee42], [0x1ee47, 0x1ee47], [0x1ee49, 0x1ee49], [0x1ee4b, 0x1ee4b], [0x1ee4d, 0x1ee4f], [0x1ee51, 0x1ee52], [0x1ee54, 0x1ee54], [0x1ee57, 0x1ee57], [0x1ee59, 0x1ee59], [0x1ee5b, 0x1ee5b], [0x1ee5d, 0x1ee5d], [0x1ee5f, 0x1ee5f], [0x1ee61, 0x1ee62], [0x1ee64, 0x1ee64], [0x1ee67, 0x1ee6a], [0x1ee6c, 0x1ee72], [0x1ee74, 0x1ee77], [0x1ee79, 0x1ee7c], [0x1ee7e, 0x1ee7e], [0x1ee80, 0x1ee89], [0x1ee8b, 0x1ee9b], [0x1eea1, 0x1eea3], [0x1eea5, 0x1eea9], [0x1eeab, 0x1eebb], [0x1eef0, 0x1eef1]] },
  { script: 'HEBREW', ranges: [[0x0591, 0x05c7], [0x05d0, 0x05ea], [0x05ef, 0x05f4], [0xfb1d, 0xfb36], [0xfb38, 0xfb3c], [0xfb3e, 0xfb3e], [0xfb40, 0xfb41], [0xfb43, 0xfb44], [0xfb46, 0xfb4f]] },
  { script: 'THAI', ranges: [[0x0e01, 0x0e3a], [0x0e3f, 0x0e5b]] },
  { script: 'DEVANAGARI', ranges: [[0x0900, 0x097f], [0xa8f2, 0xa8ff], [0x11b00, 0x11b09]] },
  { script: 'BENGALI', ranges: [[0x0980, 0x0983], [0x0985, 0x098c], [0x098f, 0x0990], [0x0993, 0x09a8], [0x09aa, 0x09b0], [0x09b2, 0x09b2], [0x09b6, 0x09b9], [0x09bc, 0x09c4], [0x09c7, 0x09c8], [0x09cb, 0x09ce], [0x09d7, 0x09d7], [0x09dc, 0x09dd], [0x09df, 0x09e3], [0x09e6, 0x09fe]] },
  { script: 'GURMUKHI', ranges: [[0x0a01, 0x0a03], [0x0a05, 0x0a0a], [0x0a0f, 0x0a10], [0x0a13, 0x0a28], [0x0a2a, 0x0a30], [0x0a32, 0x0a33], [0x0a35, 0x0a36], [0x0a38, 0x0a39], [0x0a3c, 0x0a3c], [0x0a3e, 0x0a42], [0x0a47, 0x0a48], [0x0a4b, 0x0a4d], [0x0a51, 0x0a51], [0x0a59, 0x0a5c], [0x0a5e, 0x0a5e], [0x0a66, 0x0a76]] },
  { script: 'GUJARATI', ranges: [[0x0a81, 0x0a83], [0x0a85, 0x0a8d], [0x0a8f, 0x0a91], [0x0a93, 0x0aa8], [0x0aaa, 0x0ab0], [0x0ab2, 0x0ab3], [0x0ab5, 0x0ab9], [0x0abc, 0x0ac5], [0x0ac7, 0x0ac9], [0x0acb, 0x0acd], [0x0ad0, 0x0ad0], [0x0ae0, 0x0ae3], [0x0ae6, 0x0af1], [0x0af9, 0x0aff]] },
  { script: 'ORIYA', ranges: [[0x0b01, 0x0b03], [0x0b05, 0x0b0c], [0x0b0f, 0x0b10], [0x0b13, 0x0b28], [0x0b2a, 0x0b30], [0x0b32, 0x0b33], [0x0b35, 0x0b39], [0x0b3c, 0x0b44], [0x0b47, 0x0b48], [0x0b4b, 0x0b4d], [0x0b55, 0x0b57], [0x0b5c, 0x0b5d], [0x0b5f, 0x0b63], [0x0b66, 0x0b77]] },
  { script: 'TAMIL', ranges: [[0x0b82, 0x0b83], [0x0b85, 0x0b8a], [0x0b8e, 0x0b90], [0x0b92, 0x0b95], [0x0b99, 0x0b9a], [0x0b9c, 0x0b9c], [0x0b9e, 0x0b9f], [0x0ba3, 0x0ba4], [0x0ba8, 0x0baa], [0x0bae, 0x0bb9], [0x0bbe, 0x0bc2], [0x0bc6, 0x0bc8], [0x0bca, 0x0bcd], [0x0bd0, 0x0bd0], [0x0bd7, 0x0bd7], [0x0be6, 0x0bfa], [0x11fc0, 0x11ff1], [0x11fff, 0x11fff]] },
  { script: 'TELUGU', ranges: [[0x0c00, 0x0c0c], [0x0c0e, 0x0c10], [0x0c12, 0x0c28], [0x0c2a, 0x0c39], [0x0c3c, 0x0c44], [0x0c46, 0x0c48], [0x0c4a, 0x0c4d], [0x0c55, 0x0c56], [0x0c58, 0x0c5a], [0x0c5d, 0x0c5d], [0x0c60, 0x0c63], [0x0c66, 0x0c6f], [0x0c77, 0x0c7f]] },
  { script: 'KANNADA', ranges: [[0x0c80, 0x0c8c], [0x0c8e, 0x0c90], [0x0c92, 0x0ca8], [0x0caa, 0x0cb3], [0x0cb5, 0x0cb9], [0x0cbc, 0x0cc4], [0x0cc6, 0x0cc8], [0x0cca, 0x0ccd], [0x0cd5, 0x0cd6], [0x0cdd, 0x0cde], [0x0ce0, 0x0ce3], [0x0ce6, 0x0cef], [0x0cf1, 0x0cf3]] },
  { script: 'MALAYALAM', ranges: [[0x0d00, 0x0d0c], [0x0d0e, 0x0d10], [0x0d12, 0x0d44], [0x0d46, 0x0d48], [0x0d4a, 0x0d4f], [0x0d54, 0x0d63], [0x0d66, 0x0d7f]] },
  { script: 'SINHALA', ranges: [[0x0d81, 0x0d83], [0x0d85, 0x0d96], [0x0d9a, 0x0db1], [0x0db3, 0x0dbb], [0x0dbd, 0x0dbd], [0x0dc0, 0x0dc6], [0x0dca, 0x0dca], [0x0dcf, 0x0dd4], [0x0dd6, 0x0dd6], [0x0dd8, 0x0ddf], [0x0de6, 0x0def], [0x0df2, 0x0df4], [0x111e1, 0x111f4]] },
  { script: 'KHMER', ranges: [[0x1780, 0x17dd], [0x17e0, 0x17e9], [0x17f0, 0x17f9], [0x19e0, 0x19ff]] },
  { script: 'LAO', ranges: [[0x0e81, 0x0e82], [0x0e84, 0x0e84], [0x0e86, 0x0e8a], [0x0e8c, 0x0ea3], [0x0ea5, 0x0ea5], [0x0ea7, 0x0ebd], [0x0ec0, 0x0ec4], [0x0ec6, 0x0ec6], [0x0ec8, 0x0ece], [0x0ed0, 0x0ed9], [0x0edc, 0x0edf]] },
  { script: 'MYANMAR', ranges: [[0x1000, 0x109f], [0xa9e0, 0xa9fe], [0xaa60, 0xaa7f]] },
  { script: 'ETHIOPIC', ranges: [[0x1200, 0x1248], [0x124a, 0x124d], [0x1250, 0x1256], [0x1258, 0x1258], [0x125a, 0x125d], [0x1260, 0x1288], [0x128a, 0x128d], [0x1290, 0x12b0], [0x12b2, 0x12b5], [0x12b8, 0x12be], [0x12c0, 0x12c0], [0x12c2, 0x12c5], [0x12c8, 0x12d6], [0x12d8, 0x1310], [0x1312, 0x1315], [0x1318, 0x135a], [0x135d, 0x137c], [0x1380, 0x1399], [0x2d80, 0x2d96], [0x2da0, 0x2da6], [0x2da8, 0x2dae], [0x2db0, 0x2db6], [0x2db8, 0x2dbe], [0x2dc0, 0x2dc6], [0x2dc8, 0x2dce], [0x2dd0, 0x2dd6], [0x2dd8, 0x2dde], [0xab01, 0xab06], [0xab09, 0xab0e], [0xab11, 0xab16], [0xab20, 0xab26], [0xab28, 0xab2e], [0x1e7e0, 0x1e7e6], [0x1e7e8, 0x1e7eb], [0x1e7ed, 0x1e7ee], [0x1e7f0, 0x1e7fe]] },
  { script: 'ARMENIAN', ranges: [[0x0531, 0x0556], [0x0559, 0x058a], [0x058f, 0x058f], [0xfb13, 0xfb17]] },
  { script: 'GEORGIAN', ranges: [[0x10a0, 0x10c5], [0x10c7, 0x10c7], [0x10cd, 0x10cd], [0x10d0, 0x10fb], [0x10fd, 0x10ff], [0x1c90, 0x1cba], [0x1cbd, 0x1cbf], [0x2d00, 0x2d25], [0x2d27, 0x2d27], [0x2d2d, 0x2d2d]] },
  { script: 'COPTIC', ranges: [[0x03e2, 0x03ef], [0x2c80, 0x2cf3], [0x2cf9, 0x2cff], [0x102e0, 0x102fb]] },
  { script: 'SYRIAC', ranges: [[0x0700, 0x070d], [0x070f, 0x074a], [0x074d, 0x074f], [0x0860, 0x086a]] },
  { script: 'TIBETAN', ranges: [[0x0f00, 0x0f47], [0x0f49, 0x0f6c], [0x0f71, 0x0f97], [0x0f99, 0x0fbc], [0x0fbe, 0x0fcc], [0x0fce, 0x0fd4], [0x0fd9, 0x0fda]] },
  { script: 'CYRILLIC', ranges: [[0x0400, 0x0482], [0x048a, 0x052f], [0x1c80, 0x1c88], [0x1d2b, 0x1d2b], [0xa640, 0xa66e], [0xa67e, 0xa69b], [0x1e051, 0x1e06a]] },
  { script: 'HIRAGANA', ranges: [[0x3041, 0x3096], [0x309d, 0x309f], [0x1b001, 0x1b001], [0x1b11f, 0x1b11f], [0x1b132, 0x1b132], [0x1b150, 0x1b152]] },
  { script: 'KATAKANA', ranges: [[0x309b, 0x309c], [0x30a0, 0x30ff], [0x31f0, 0x31ff], [0x1aff0, 0x1aff3], [0x1aff5, 0x1affb], [0x1affd, 0x1affe], [0x1b000, 0x1b000], [0x1b120, 0x1b122], [0x1b155, 0x1b155], [0x1b164, 0x1b167]] },
  { script: 'BOPOMOFO', ranges: [[0x3105, 0x312f], [0x31a0, 0x31bf]] },
];

const BLOCKED_SCRIPT_PATTERN = BLOCKED_SCRIPT_RANGES
  .flatMap(({ ranges }) =>
    ranges.map(
      ([start, end]) =>
        `\\u{${start.toString(16)}}-\\u{${end.toString(16)}}`,
    ),
  )
  .join('');

// Compile the combined character class once. Script attribution is only
// resolved after this fast guard finds the first blocked character.
const BLOCKED_SCRIPT_REGEX = new RegExp(`[${BLOCKED_SCRIPT_PATTERN}]`, 'u');

// Match the server's normalize_passage_dashes. Preserve Kana words such as
// コーヒー; only a standalone, whitespace-delimited mark is used as a dash.
export function normalizePassageDashes(text: string): string {
  return text.replace(/(^|\s)ー(?=\s|$)/gu, '$1—');
}

export function detectLanguageGuardViolation(text?: string | null): LanguageGuardViolation | null {
  if (!text) return null;
  text = normalizePassageDashes(normalizePassageText(text));

  const match = BLOCKED_SCRIPT_REGEX.exec(text);
  if (!match) return null;

  const char = match[0];
  const codepointNumber = char.codePointAt(0);
  if (codepointNumber === undefined) return null;

  const script = getBlockedScript(codepointNumber);
  if (!script) return null;

  const chars = Array.from(text);
  const position = Array.from(text.slice(0, match.index)).length;

  return {
    script,
    char,
    codepoint: `U+${codepointNumber.toString(16).toUpperCase().padStart(4, '0')}`,
    position,
    snippet: makeSnippet(chars, position),
  };
}

export function preparePassageForGeneration(text: string, fieldLabel = '지문'): string {
  const normalized = normalizePassageDashes(normalizePassageText(text));
  const violation = detectLanguageGuardViolation(normalized);
  if (violation) throw new Error(formatLanguageGuardFeedback(violation, fieldLabel));
  return normalized;
}

export function formatLanguageGuardFeedback(
  violation: LanguageGuardViolation,
  fieldLabel: string = '지문'
): string {
  return `${fieldLabel}에 허용되지 않는 문자 '${violation.char}' (${violation.script}, ${violation.codepoint})가 포함되어 입력할 수 없습니다. 주변 텍스트: "${violation.snippet}"`;
}

function getBlockedScript(codepoint: number): string | null {
  for (const entry of BLOCKED_SCRIPT_RANGES) {
    if (entry.ranges.some(([start, end]) => codepoint >= start && codepoint <= end)) {
      return entry.script;
    }
  }
  return null;
}

function makeSnippet(chars: string[], index: number, radius: number = 20): string {
  const start = Math.max(0, index - radius);
  const end = Math.min(chars.length, index + radius + 1);
  return chars.slice(start, end).join('').replace(/\n/g, '\\n');
}
